import { AdministrationPage } from './AdministrationPage'
export function FullAdministrationPage(){return <AdministrationPage/>}
